module.exports = "<div class=\"{{baCheckboxClass}}\">\n  <label class=\"checkbox-inline custom-checkbox nowrap\">\n    <input type=\"checkbox\" [checked]=state\n           (change)=\"onChange($event.target.checked)\"\n           [disabled]=\"disabled\" [value]=\"value\">\n    <span>{{label}}</span>\n  </label>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baCheckbox/baCheckbox.html
// module id = ./src/app/theme/components/baCheckbox/baCheckbox.html
// module chunks = main